import { Route, Routes } from "react-router-dom";

import Sidebar from "./components/Sidebar";
import { ReportProvider } from "./context/ReportContext";
import Admin from "./pages/Admin";
import Audit from "./pages/Audit";
import Home from "./pages/Home";
import Report from "./pages/Report";

export default function App() {
  return (
    <ReportProvider>
      <div className="min-h-screen lg:flex">
        <Sidebar />
        <main className="flex-1 min-w-0 px-4 sm:px-6 py-6 lg:px-8 lg:py-8">
          <div className="mx-auto max-w-6xl">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/audit" element={<Audit />} />
              <Route path="/r/:slug" element={<Report />} />
              <Route path="/r/:slug/:metric" element={<Report />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </main>
      </div>
    </ReportProvider>
  );
}

function NotFound() {
  return <p className="text-gray-400">Not found.</p>;
}
